import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy} from '@angular/core';
import { SelectItem } from 'primeng/api';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { CalltoactionService } from '@irb-common/components/calltoaction//calltoaction.service';

@Component({ standalone: false,
  selector: 'irb-pick-list',
  templateUrl: './pick-list.component.html',
  styleUrls: ['./pick-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager
})
export class IrbPickListComponent implements OnInit {
  @Input() sourceData: Array<SelectItem>;
  @Input() targetData: Array<SelectItem>;
  @Output() onMoveToTarget: EventEmitter<any> = new EventEmitter();
  @Output() onMoveToSource: EventEmitter<any> = new EventEmitter();
  @Output() onMoveAllToTarget: EventEmitter<any> = new EventEmitter();
  @Output() onMoveAllToSource: EventEmitter<any> = new EventEmitter();
  @Output() onApplyFilter: EventEmitter<any> = new EventEmitter();
  sourceSelection: Array<SelectItem> = [];
  targetSelection: Array<SelectItem> = [];
  faTimes = faTimes;
  filterText: string = "";

  constructor(private ctas: CalltoactionService) { }

  ngOnInit() {
  }

  onAdd() {
    this.onMoveToTarget.emit(this.sourceSelection);
    this.sourceSelection = [];
  }

  onAddAll() {
    this.onMoveAllToTarget.emit(true);
    this.sourceSelection = [];
  }

  onRemove() {
    this.ctas.remove();
    this.onMoveToSource.emit(this.targetSelection);
    this.targetSelection = [];
  }

  onRemoveAll() {
    this.ctas.remove();
    this.onMoveAllToSource.emit(true);
    this.targetSelection = [];
  }

  onCancel() {
    this.ctas.remove();
  }

  applyFilter() {
    this.onApplyFilter.emit(this.filterText);
  }

  clearFilter() {
    this.filterText = "";
    this.onApplyFilter.emit(this.filterText);
  }
}
